var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"light-gray"},[_vm._v("\n    "+_vm._s(_vm.$t('placeholder.age'))+"\n  ")]),_vm._v(" "),_c('Slider',{staticClass:"age-slider",attrs:{"value":_vm.trainerAge,"min-value":_vm.minAge,"max-value":_vm.maxAge,"post-str":_vm.$t('common.years')},on:{"changeValue":_vm.getAge}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }